import React from 'react'
import { Box, Typography, Dialog, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Icon } from 'packages/eid-icons'
import { IconButton } from 'packages/eid-ui'
import { mobileScreenWidth } from 'utils'

const StyledModal = styled(Box)({
    backgroundColor: '#f7f8fa',
    borderRadius: '8px',
    boxShadow: '0 0 13px 0 rgba(0, 0, 0, 0.15)',
    padding: '24px 40px',
    '&:focus': {
        outline: 'none',
    },

    [`@media (max-width:${mobileScreenWidth})`]: {
        padding: '24px 16px',
    },
})

const StyledModalHeader = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    maxHeight: '12%',
    padding: '16px 0px',
})

const StyledTitle = styled(Typography)({
    fontSize: '24px',
    fontWeight: 'normal',
    color: '#282828',
})

const StyledCloseIcon = styled(Box)({
    display: 'flex',
    marginRight: '-16px',
    marginTop: '-16px',
    height: '10px',
})

const StyledDialog = styled(Dialog)({
    '& .MuiDialog-paper': {
        [`@media (max-width:${mobileScreenWidth})`]: {
            margin: '8px',
            width: 'calc(100% - 16px) !important',
            maxWidth: 'calc(100% - 16px) !important ',
        },
    },

    '& .MuiDialog-paperWidthSm': {
        maxWidth: '760px',
    },
})

const Modal = ({ open, onClose, title, children }) => {
    const { t } = useTranslation()

    return (
        <StyledDialog
            fullWidth
            scroll={'body'}
            open={open}
            onClose={onClose}
            aria-labelledby="modal-title"
            maxWidth="sm"
        >
            <StyledModal>
                <StyledModalHeader>
                    <StyledTitle id="modal-title">{title}</StyledTitle>
                    <StyledCloseIcon>
                        <IconButton
                            onClick={onClose}
                            size="large"
                            aria-label="Close"
                        >
                            <Icon name="Close" color="#959598" />
                        </IconButton>
                    </StyledCloseIcon>
                </StyledModalHeader>

                {children}
            </StyledModal>
        </StyledDialog>
    )
}

export default Modal
